import React, { useEffect } from 'react';
import { Profile, View } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import useTypedDispatch from '../../helpers/useDispatch';
import HighlightedProfiles from '../HighlightedProfiles';

interface RelatedContentProps extends React.ComponentPropsWithoutRef<'div'> {
  themeId: number;
  theme?: any;
}

const RelatedContent: React.FC<RelatedContentProps> = ({
  themeId,
  theme,
}) => {
  const { t } = useTranslation();

  const contactProfileId = theme.field_contact_person[0]?.target_id ?? null;
  const contactProfileName: any = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['profile', contactProfileId, 'field_full_name', 0, 'value'], null));

  return (
    <div className="row">
      <div className="col-lg-7 content-section mt-0">
        <View
          key={`nested_taxonomies:${themeId}`}
          id="taxonomy"
          display="nested"
          args={[themeId]}
          title={t('pages.taxonomy_theme_page.subjects')}
          resetStateOnUnmount
        />
      </div>
      <div className="col-12 col-lg-5">
        {contactProfileId && contactProfileId !== -1 && (
          <div className="sidebar-section">
            <HighlightedProfiles heading={t('components.default_profile_teaser.title', { name: contactProfileName })}>
              <Profile
                id={contactProfileId}
              />
            </HighlightedProfiles>
          </div>
        )}
        <View
          key={`docs_by_theme:${themeId}`}
          id="docs"
          display="docs_by_theme"
          args={[themeId, 'document']}
          resetStateOnUnmount
        />
      </div>
    </div>
  );
};

export default RelatedContent;
